<template>
  <div class="flex justify-end" ref="dropdownConsultationFee">
    <div class="relative">
      <div class="text flex justify-between cursor-pointer" @click="showOptions = !showOptions"> 
        <div>{{ $t("OrderPage[\"+ Customize Fee\"]") }}</div>
        <span 
          class="arrow material-icons-outlined transition-transform -"
          :class="{'rotate-arrow': showOptions}"
        >
          keyboard_arrow_down
        </span>
      </div>
      <div class="options absolute mt-2" :class="isMarkupEligible ? '' : 'short'" v-if="showOptions">
        <div class="option cursor-pointer flex items-center" @click="openConsultationFeeDialog">
          {{ $t("OrderPage[\"Consultation Fee\"]") }}
        </div>
        <div v-if="isMarkupEligible" class="option cursor-pointer flex items-center" @click="openMarkupDialog">
          {{ $t("OrderPage[\"Test Revenue\"]") }}
        </div>
      </div>
    </div>
    <ConsultationFeeDialog 
      :is-show-dialog="isShowConsultationDialog"
      @close="isShowConsultationDialog = false"
    />
    <MarkupDialog
      :is-show-dialog="isShowMarkupDialog"
      @close="isShowMarkupDialog = false"
    />
  </div>
</template>

<script>
import ConsultationFeeDialog from './ConsultationFeeDialog.vue';
import MarkupDialog from './MarkupDialog.vue';
import { mapGetters } from 'vuex';


export default {
  components: {
    ConsultationFeeDialog,
    MarkupDialog,
  },

  props: {
    count: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      showOptions: false,
      isShowConsultationDialog: false,
      isShowMarkupDialog: false,
    }
  },

  computed: {
        ...mapGetters("orderTest/order", ["isMarkupEligible"]),
  },

  watch: {
    count(newVal) {
      if (newVal > 0) {
        this.isShowConsultationDialog = true;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    openConsultationFeeDialog() {
      this.isShowConsultationDialog = true;
      this.showOptions = false;
    },
    openMarkupDialog() {
      this.isShowMarkupDialog = true;
      this.showOptions = false;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdownConsultationFee && !this.$refs.dropdownConsultationFee.contains(event.target)) {
        this.showOptions = false;
      }
    },
  }
}
</script>

<style scoped>
.text {
  width: 147px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  letter-spacing: 0.45;
  text-align: left;
  color: #004879;
}

.arrow {
  font-size: 14px;
  color: #000000;
  opacity: 0.87;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: transform 0.2s;
  transform-origin: center;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.option {
  width: 177px;
  height: 36px;

  padding-left: 24px;
}

.option:hover {
  color: #004879;
}

.options {
  width: 177px;
  height: 72px;
  border-radius: 4px;
  background: #FFFFFF;
  box-shadow: 0px 4px 6px 0px #00000029;
  z-index: 99;
}

.short {
  height: 36px;
}
</style>